/**
 * The link an inviter copies to the person they invite (owner 2026-10-23: no email provider yet). It opens the
 * invitation page on this deployment's own origin; the sign-up behind it works only for the invited email.
 */
export function invitationLink(token: string, origin: string = window.location.origin): string {
  return `${origin}/invite/accept?token=${encodeURIComponent(token)}`;
}
